import { Navigate, Outlet } from 'react-router'
import { RouteHeader } from '../constant/routeAndHeader';
import FullLayout from '../layouts/full/FullLayout';
import Label from '../components/xaoasoft/label';
import Customizemenu from '../layouts/full/customizemenu/customizemenu';
import { FarsiRouteHeader } from '../constant/farsiRouteandHeader';
import { LanguageChecker } from '../constant/langaugechecker';

const webSrn = localStorage.getItem('WebSrn')
const authData = LanguageChecker() ? FarsiRouteHeader().router.auth : RouteHeader().router.auth;
const SinglePage = LanguageChecker() ? FarsiRouteHeader().router.SinglePage : RouteHeader().router.SinglePage;
const PrivateRoute = LanguageChecker() ? FarsiRouteHeader().router.Menu : RouteHeader().router.Menu;



export const Router = [
    {
        path:'/',
        elemenet: <><Outlet /><Label /></>,
        children:[
            ...SinglePage
            // ,
            // {}
        ]
    },
    {
        path: '/auth/',
        element: <><Outlet /><Label /></>,
        children:[
            ...authData
        ]
    },
    {
        path: '/Private/',
        element: <div id='fullLayout'><FullLayout /></div>,
        children:[
            ...PrivateRoute
        ]
    }
];